import { render, staticRenderFns } from "./IconTelegramFooter.vue?vue&type=template&id=219e4f1a&"
import script from "./IconTelegramFooter.vue?vue&type=script&lang=js&"
export * from "./IconTelegramFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('219e4f1a')) {
      api.createRecord('219e4f1a', component.options)
    } else {
      api.reload('219e4f1a', component.options)
    }
    module.hot.accept("./IconTelegramFooter.vue?vue&type=template&id=219e4f1a&", function () {
      api.rerender('219e4f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconTelegramFooter.vue"
export default component.exports